var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticStyle:{"text-align":"left"}},[(_vm.modo == 'new' || _vm.modo == 'edit' || _vm.modo == 'flow')?[_c('crud-tag',{attrs:{"embedprops":{
        params: { module: _vm.getComponentParam('tabela'), action: 'list' },
        query: {
          joinedid: _vm.crud.actionid || _vm.localvalue,
          joined: _vm.getComponentParam('chaveext')
        },
        props: {
          filtro: false,
          gc: false,
          rodape: false,
          titulo: false,
          select: false,
          exportscreen: false,
          exportserver: false
        }
      }}})]:_vm._e(),(_vm.modo == 'list' || _vm.modo == 'view' || _vm.modo == 'viewmode')?[_c('div',{class:{ 'text-xs-center': _vm.crud.action == 'list' }},[_c('v-card',{staticClass:"blue lighten-5"},[_c('crud-tag',{attrs:{"embedprops":{
            params: { module: _vm.getComponentParam('tabela'), action: 'list' },
            query: {
              joinedid: _vm.row.id || _vm.crud.actionid || _vm.localvalue,
              joined: _vm.getComponentParam('chaveext')
            },
            props: {
              acoes: false,
              filtro: false,
              gc: false,
              rodape: false,
              titulo: false,
              select: false,
              exportscreen: false,
              exportserver: false
            }
          }}})],1)],1)]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }